import React, { useEffect, useState } from "react";
import { ApiConfig } from "../../../api/apiConfig/ApiConfig";
import AuthService from "../../../api/services/AuthService";
import { alertErrorMessage, alertSuccessMessage } from "../../../customComponent/CustomAlertMessage";
import { CSVLink } from "react-csv";
import LoaderHelper from "../../../customComponent/Loading/LoaderHelper";
import moment from "moment";
import DataTableBase from "../../../customComponent/DataTable";
import SIPUserPopup from "./SIPUserPopup";

const SIPUsersList = () => {
    const [fundsDeposit, setFundsDeposit] = useState([]);
    const [allData, setAllData] = useState([]);
    // Investment modal states
    const [showInvestmentModal, setShowInvestmentModal] = useState(false);
    const [selectedAffiliate, setSelectedAffiliate] = useState(null);
    const [investmentData, setInvestmentData] = useState({ amount: '', self_roi_percent: '', uplines: [] });
    const [currency, setCurrency] = useState("INR");
    const [walletBalance, setWalletBalance] = useState(0);
    const [packageDetails, setPackageDetails] = useState(null);
    const [packageList, setPackageList] = useState([]);
    // SIP User Popup states
    const [showSIPUserPopup, setShowSIPUserPopup] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);

    const userIdFollow = (row) => {
        return (
            <button 
                className="btn btn-link p-0 text-primary text-decoration-underline"
                onClick={() => openSIPUserPopup(row.investor)}
            >
                {row.investor._id}
            </button>
        );
    };

    const handleImageShow = (row) => {
        return (
            row?.installmentschedules?.transaction_slip ? <a href={ApiConfig?.appUrl + row?.installmentschedules?.transaction_slip} target="_blank" rel="noreferrer">  <img style={{ width: "40%", height: "auto" }} src={ApiConfig?.appUrl + row?.installmentschedules?.transaction_slip} alt="Receipt" className="table-img cursor_pointer" /></a> : "---"
        );
    };



    const columns = [
        { name: "User ID", wrap: true, selector: userIdFollow },
        { name: "Email", wrap: true, selector: row => row.investor.emailId, },
        { name: "Recent SIP ", selector: row => moment(row?.investmentDate).format("MMM Do YYYY"), wrap: true },
        { name: "Total SIP Accounts", sortable: true, wrap: true, selector: row => `${row.sipCount}`, },
        { name: "Total Invested", sortable: true, wrap: true, selector: row => `${row.totalAmount?.toFixed(2)}`, },
    ];

    useEffect(() => {
        handleFundDeposit();
    }, []);

    const handleFundDeposit = async () => {
        LoaderHelper.loaderStatus(true);
        await AuthService.getSIPRequests("ACTIVE","SIP").then(async result => {
            LoaderHelper.loaderStatus(false);
            if (result.success) {
                try {
                    // Group data by investor._id
                    const groupedData = result.data.reduce((acc, item) => {
                        const investorId = item.investor._id;
                        
                        if (!acc[investorId]) {
                            acc[investorId] = {
                                ...item,
                                totalAmount: 0,
                                sipCount: 0,
                                allSips: []
                            };
                        }
                        
                        acc[investorId].totalAmount += parseFloat(item.amount || 0);
                        acc[investorId].sipCount += 1;
                        acc[investorId].allSips.push(item);
                        
                        // Keep the latest investment date
                        if (new Date(item.investmentDate) > new Date(acc[investorId].investmentDate)) {
                            acc[investorId].investmentDate = item.investmentDate;
                        }
                        
                        return acc;
                    }, {});
                    
                    // Convert grouped object back to array
                    const groupedArray = Object.values(groupedData);
                    
                    setFundsDeposit(groupedArray);
                    setAllData(groupedArray);
                } catch (error) {
                    alertErrorMessage(error);
                }
            } else {
                LoaderHelper.loaderStatus(false);
            }
        });
    };

    function handleSearch(e) {
        const keysToSearch = ["chain", "currency", "emailId", "firstName", "from_address", "to_address", "transaction_hash", "amount", "mobileNumber", "user_id"];
        const searchTerm = e.target.value?.toLowerCase();
        const matchingObjects = allData.filter(obj => { return keysToSearch.some(key => obj[key]?.toString()?.toLowerCase()?.includes(searchTerm)) });
        setFundsDeposit(matchingObjects);
    };

    const openSIPUserPopup = (user) => {
        setSelectedUser(user);
        setShowSIPUserPopup(true);
    };

    return (
        <div id="layoutSidenav_content">
            <main>
                
                <div className="container-xl px-4 mt-n10">
                    <div className="card mb-4">
                        <div className="card-header">
                            SIP Users

                            <div className="col-5">
                                <input className="form-control form-control-solid" id="inputLastName" type="text" placeholder="Search here..." name="search" onChange={handleSearch} />
                            </div>
                            {fundsDeposit.length === 0 ? "" :
                                <div className="dropdown">
                                    <button className="btn btn-dark btn-sm dropdown-toggle" id="dropdownFadeInUp" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Export{" "}
                                    </button>
                                    <div className="dropdown-menu animated--fade-in-up" aria-labelledby="dropdownFadeInUp">
                                        <CSVLink data={fundsDeposit} className="dropdown-item">Export as CSV</CSVLink>
                                    </div>
                                </div>}
                        </div>
                        <div className="table-responsive mt-4" width="100%">
                            <DataTableBase columns={columns} data={fundsDeposit} />
                        </div>
                    </div>
                </div>

                {/* SIP User Popup Modal */}
                {showSIPUserPopup && selectedUser && (
                    <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.8)', zIndex: 9999 }}>
                        <div className="modal-dialog modal-xl ">
                            <div className="modal-content" style={{ background: '#1a1a1a', color: '#fff' }}>
                                <div className="modal-header" style={{ borderBottom: '1px solid #444' }}>
                                    <h5 className="modal-title" style={{ color: '#FFDC88' }}>
                                        SIP Details - {selectedUser.firstName} {selectedUser.lastName}
                                    </h5>
                                    <button 
                                        className="btn-close btn-close-white" 
                                        onClick={() => setShowSIPUserPopup(false)}
                                    ></button>
                                </div>
                                <div className="modal-body p-0" style={{ height: 'calc(100vh - 120px)', overflow: 'hidden' }}>
                                    <div style={{ height: '100%', overflow: 'auto', padding: '20px' }}>
                                        <SIPUserPopup selectedUser={selectedUser} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
        </div>
    )
}
export default SIPUsersList;